module.exports = __webpack_public_path__ + "media/images/bnr_header_discount_pc-d2d1cb5697113606a21585b9836ba61b.jpg";